/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModule_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationItems_viewer">;
    readonly " $refType": "HpRespLocationsModule_viewer";
};
export type HpRespLocationsModule_viewer$data = HpRespLocationsModule_viewer;
export type HpRespLocationsModule_viewer$key = {
    readonly " $data"?: HpRespLocationsModule_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModule_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespLocationsModule_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "HpRespLocationItems_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '6f46ede06d7ce74f09b6e6e6987cd223';
export default node;
